import type { CSSProperties } from 'react'

import { useBoundStore } from '../../store/store'
import { TailSpin } from '../loaders'

interface SpinnerProps {
  containerStyle?: CSSProperties
  spinnerSize?: number
}

const Spinner = ({ containerStyle, spinnerSize }: SpinnerProps) => {
  const theme = useBoundStore(state => state.common.theme)

  return (
    <div className="flx-ctr w-full" style={containerStyle}>
      <TailSpin
        color={theme === 'dark' ? '#fff' : '#0E091E'}
        width={spinnerSize ?? 40}
        height={spinnerSize ?? 40}
      />
    </div>
  )
}

export default Spinner
